import React from 'react';
import { Home, Facebook, Instagram, Linkedin, Globe, Mail } from 'lucide-react';

const SOCIAL_LINKS = [
  { icon: Facebook, label: 'Facebook' },
  { icon: Instagram, label: 'Instagram' },
  { icon: Linkedin, label: 'LinkedIn' },
];

const QUICK_LINKS = [
  { href: '/#forms', label: 'Get Cash Offer' },
  { href: '/#forms', label: 'Join Buyer List', key: 'buyer' },
  { href: '/#how-it-works', label: 'How It Works' },
  { href: '/#markets', label: 'Markets We Serve' },
  { href: '/#who-we-help', label: 'Who We Help' },
];

const BrandColumn = () => (
  <div>
    <div className="flex items-center gap-3 mb-6">
      <div className="w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center">
        <Home className="w-5 h-5 text-white" />
      </div>
      <span className="text-xl font-bold text-white">DreamHousesUSA</span>
    </div>
    <p className="text-slate-400 leading-relaxed mb-6">
      Professional real estate investment company helping homeowners sell fast and investors find off-market deals.
    </p>
    <div className="flex gap-4">
      {SOCIAL_LINKS.map(({ icon: Icon, label }) => (
        <a key={label} href="#" aria-label={label} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-slate-400 hover:bg-emerald-500 hover:text-white transition-all duration-300">
          <Icon className="w-5 h-5" />
        </a>
      ))}
    </div>
  </div>
);

const QuickLinksColumn = () => (
  <div>
    <h3 className="text-white font-semibold mb-6">Quick Links</h3>
    <ul className="space-y-3">
      {QUICK_LINKS.map((l) => (
        <li key={l.key || l.label}>
          <a href={l.href} className="text-slate-400 hover:text-emerald-400 transition-colors">{l.label}</a>
        </li>
      ))}
    </ul>
  </div>
);

const ContactColumn = ({ contactInfo }) => (
  <div>
    <h3 className="text-white font-semibold mb-6">Contact Us</h3>
    <div className="space-y-4">
      <a
        href={`https://${contactInfo.website}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 text-slate-400 hover:text-emerald-400 transition-colors"
      >
        <Globe className="w-5 h-5" />
        <span>{contactInfo.website}</span>
      </a>
      <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-3 text-slate-400 hover:text-emerald-400 transition-colors">
        <Mail className="w-5 h-5" />
        <span>{contactInfo.email}</span>
      </a>
    </div>
    <div className="mt-6 p-4 bg-white/5 rounded-xl">
      <p className="text-sm text-slate-500">{contactInfo.tagline}</p>
    </div>
  </div>
);

const FooterMain = ({ contactInfo }) => (
  <div className="container mx-auto px-6 py-16">
    <div className="grid md:grid-cols-3 gap-12">
      <BrandColumn />
      <QuickLinksColumn />
      <ContactColumn contactInfo={contactInfo} />
    </div>
  </div>
);

export default FooterMain;
